export const SHOW_RESTRICTIONS_MODAL = "SHOW_RESTRICTIONS_MODAL";
export const SHOW_RESTRICTIONS_MODAL_HIDE = "SHOW_RESTRICTIONS_MODAL_HIDE";
